import { render, staticRenderFns } from "./MagicPage.vue?vue&type=template&id=5ea4db15&scoped=true&"
import script from "./MagicPage.vue?vue&type=script&lang=js&"
export * from "./MagicPage.vue?vue&type=script&lang=js&"
import style0 from "./MagicPage.vue?vue&type=style&index=0&id=5ea4db15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4db15",
  null
  
)

export default component.exports